import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { ContactUs } from '../contact-us.model';
import { ContactUsActions, ContactUsActionTypes } from '../actions/contact-us.actions';

export interface State extends EntityState<ContactUs> {
  // additional entities state properties
}

export const adapter: EntityAdapter<ContactUs> = createEntityAdapter<ContactUs>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(
  state = initialState,
  action: ContactUsActions
): State {
  switch (action.type) {
    case ContactUsActionTypes.AddContactUs: {
      return state;
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
